export default __webpack_public_path__ + "static/media/Acolyte's Belt of the Limitless Cipher.90b26089.jpg";